/**
 * @file        constants.js
 *              Exports for various constants the system uses. Exported as dcp/constants in
 *              dcp-client.
 * @author      Ryan Saweczko, ryansaweczko@distributive.network
 * @date        Feb 2026
 */
'use strict';

exports.scheduler = require('./scheduler-constants.js');
Object.assign(exports.scheduler.capabilities, require('./capabilities'));
